import { createSlice } from "@reduxjs/toolkit";
import {
  createOrUpdateStripeAccount,
  fetchMemberDetails,
  fetchMembersItems,
  fetchStripeAccount,
  updateMembersItem,
} from "./MembersThunks";

const initialState = {
  items: [],
  loading: false,
  error: null,
   account: null,
};

const membersSlice = createSlice({
  name: "members",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchMembersItems.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchMembersItems.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload;
      })
      .addCase(fetchMembersItems.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(fetchMemberDetails.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchMemberDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.user = action.payload;
        localStorage.setItem("member", JSON.stringify(action.payload)); // sync to localStorage
      })
      .addCase(fetchMemberDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to fetch member details";
      })
      // Handle updateMembersItem here
      .addCase(updateMembersItem.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateMembersItem.fulfilled, (state, action) => {
        state.loading = false;
        const updatedMember = action.payload;

        // Only set if payload is not an error message
        if (updatedMember && !updatedMember.message) {
          localStorage.setItem("member", JSON.stringify(updatedMember));
        }
      })
      .addCase(updateMembersItem.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to update member";
      }) 
      // Fetch account
      .addCase(fetchStripeAccount.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchStripeAccount.fulfilled, (state, action) => {
        state.loading = false;
        state.account = action.payload;
      })
      .addCase(fetchStripeAccount.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      })
      // Create/Update account
      .addCase(createOrUpdateStripeAccount.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createOrUpdateStripeAccount.fulfilled, (state, action) => {
        state.loading = false;
        state.account = action.payload;
      })
      .addCase(createOrUpdateStripeAccount.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      });
  },
});

export default membersSlice.reducer;
